import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject, isDevMode } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';
import { ComponentType } from 'hx-services';
import Keycloak from 'keycloak-js';
import { ToastrService } from 'ngx-toastr';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ACCESS_API_PREFIX, AccessForbiddenService } from '@adm-web-app/modules/access/services/access-forbidden.service';
import { AccessRecentService } from '@adm-web-app/modules/access/services/access-recent.service';

/**
 * Language and component headers for every request; a 401 means the session is gone: the people «Недавние» of the page «Доступы» are wiped and the user goes to the login.
 * Everything is injected at the top: the callback of `catchError` runs outside of an injection context.
 */
export const customHttpInterceptorFn: HttpInterceptorFn = (req, next) => {
  const kc = inject(Keycloak);
  const toastr = inject(ToastrService);
  const tr = inject(TranslocoService);
  const recent = inject(AccessRecentService);
  const forbidden = inject(AccessForbiddenService);
  let headers = req.headers.set('Accept-Language', tr.getActiveLang());
  if (isDevMode()) {
    headers = headers.set('component', ComponentType.adm);
  }
  return next(req.clone({headers: headers})).pipe(catchError(error => {
    if (error instanceof HttpErrorResponse) {
      if (error.status === 401) {
        recent.clear();
        kc.logout();
      }

      if (error.status === 403 && req.url.startsWith(ACCESS_API_PREFIX)) {
        // not an administrator: the page «Доступы» shows one state instead of the tabs
        forbidden.mark();
      }

      if (error.status === 502 || error.status === 504) {
        toastr.error(`Ошибка ${error.status} - Проблемы с сервером или интернетом (${req.url.split('/')[2]})`);
      }

      if (error.status === 500) {
        toastr.error(`Ошибка ${error.status} - ${error.statusText}`);
      }
    }

    return throwError(() => error);
  }));
};
